<template lang="html">
<div>
  <!-- <v-parallax
    :src="require('../../assets/SocialGames/Background_SMVS.png')"
  > -->
  <v-container fluid pa-0>
    <v-layout>
      <v-flex xs12>
        <v-img :src="require('../../assets/SocialGames/Background_SMVS.png')">
          <div class="overall-container">
            <div class="banner-container">
              <!-- <img :src="require('../../assets/SocialGames/Phone_SMVS.png')" class="phone-smv" /> -->
              <v-img
                :src="smvPhone"
                :max-height="700"
                :max-width="'100%'"
                contain
                :position="'center right'"
              ></v-img>
              <v-container class="parallax-container px-0 more-styling">
                <v-layout>
                  <v-flex xs12 sm8 md6 lg5 xl4 class="text-xs-left">
                    <v-img
                      :src="smvIcon"
                      :max-width="'30%'"
                      aspect-ratio="1"
                      contain
                      :position="'center left'"
                    ></v-img>
                    <h1 class="about-title text-xs-left">Show Me Vegas Slots<sup>&trade;</sup></h1>
                    <h4 class="about-subtitle text-xs-left">Real Casino Slots, Real Excitement!</h4>

                    <v-flex xs12 sm12 md12 lg12 xl10 class="text-xs-left">
                      <p class="body-text text-xs-left">Bring Las Vegas Home! &nbsp;Spin the reels and enjoy real Vegas casino slots like "Ghost Island", "Fishing Bob", "Super Sally's Shrimpmania"; all packed with unique features, HUGE PAYOUTS &amp; fun gameplay!</p>
                      <!-- <v-img
                        :src="smvButton"
                        @click="smvClick"
                        @mouseenter="changeButton"
                        @mouseleave="defaultButton"
                        id="smvBtn"
                      ></v-img> -->
                      <a href="https://showmevegasslots.onelink.me/uBTP?utm_source=ksg_web&utm_medium=website_click&utm_campaign=ksg_webtosmvsapp&utm_content=playforfreebutton&utm_term=all_users&pid=ksg_web&c=ksg_webtosmvsapp&af_dp=com.ksgmobileinc.showmevegasslotsv2" target="_blank" v-if="!mobile && !ipad">
                        <img :src="smvButton" id="pcBtn" alt="Show Me Vegas Play Button" style="width: 100%;" @mouseover="changeButton('pc-smvHover')" @mouseleave="defaultButton('pc-smvButton')" />
                      </a>
                      <a href="https://showmevegasslots.onelink.me/uBTP?utm_source=ksg_web&utm_medium=website_click&utm_campaign=ksg_webtosmvsapp&utm_content=playforfreebutton&utm_term=all_users&pid=ksg_web&c=ksg_webtosmvsapp&af_dp=com.ksgmobileinc.showmevegasslotsv2" target="_blank" v-else>
                        <img :src="smvButton" id="pcBtn" alt="Show Me Vegas Play Button" style="width: 100%;" @mouseover="changeButton('pc-smvHover')" @mouseleave="defaultButton('pc-smvButton')" />
                      </a>
                      <v-layout row>
                        <v-flex xs6 sm12 md12 lg12>
                          <a class="storeLinks" href="http://link.showmevegasslots.com/ShowMeVegasSlots_iOSAppStore" style="display:inline-block; width: 100%; height: 100%;" target="_blank" id="iosBtn"><v-img :src="iosStore" contain></v-img></a>
                        </v-flex>

                        <v-flex xs6 sm12 md12 lg12>
                          <a class="storeLinks" href="http://link.showmevegasslots.com/ShowMeVegasSlots_GooglePlayStore" style="display:inline-block; width: 100%; height: 100%;" target="_blank" id="googleBtn"><v-img :src="googlePlay" contain ></v-img></a>
                        </v-flex>
                      </v-layout>

                      <v-layout row v-if="!mobile">
                        <v-flex xs6 sm12 md12 lg12>
                          <a class="storeLinks" href="https://showmevegasslots.onelink.me/uBTP?promoLink=UmMlkY2Q4dYjMkW7&utm_source=KSGWebSite&utm_medium=ksg_website_web&utm_campaign=Persistent%2Cwebsite_connect%2CNULL%2CNULL&utm_content=NULLApp_Button&utm_term=G1%2CV0%2CNULL%2CR0%2C&pid=KSGWebSite&c=website_connect&af_dp=com.ksgmobileinc.showmevegasslotsv2%3A%2F%2F" style="display:inline-block; text-align: center; margin-top: -1.5rem;" target="_blank" id="facebookBtn"><img :src="smvFacebook" style="width: 50%; height: 50%;"></a>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </div>
        </v-img>
      </v-flex>
    </v-layout>
  </v-container>
  <!-- </v-parallax> -->

  <v-container class="smv-container">
    <v-layout justify-center>
      <v-flex xs12 sm8 md8 lg6 xl6>
        <hr>
        <h3 class="text-xs-left" style="margin: 1rem 0;">Video Preview</h3>
        <div class="iframe-container">
          <iframe
            width="480"
            height="345"
            src="https://www.youtube.com/embed/ee4VBqXP-QY?rel=0&utm_source=KSGWebSite&utm_medium=ksg_website_web&utm_campaign=Persistent"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            >
          </iframe>
        </div>

        <hr style="margin-top: 1rem;">
        <h3 class="text-xs-left" style="margin: 1rem 0;">Screenshots</h3>
        <div class="screenshots-container">
          <div class="horizontal-scroll">
            <v-img v-for="(image, i) in screenshots"
              :src="image"
              :max-height="400"
              :key="i"
              contain
            ></v-img>
            <!-- <v-img
            src="https://picsum.photos/350/165?random"
            class="grey darken-4"
            ></v-img>
            <v-img
            src="https://picsum.photos/350/165?random"
            class="grey darken-4"
            ></v-img>
            <v-img
            src="https://picsum.photos/350/165?random"
            class="grey darken-4"
            ></v-img>
            <v-img
            src="https://picsum.photos/350/165?random"
            class="grey darken-4"
            ></v-img>
            <v-img
            src="https://picsum.photos/350/165?random"
            class="grey darken-4"
            ></v-img>
            <v-img
            src="https://picsum.photos/350/165?random"
            class="grey darken-4"
            ></v-img> -->
          </div>
        </div>

        <hr style="margin-top: 1rem;">
        <h3 class="text-xs-left" style="margin: 1rem 0;">App Description</h3>
        <p class="text-xs-left">Bring Las Vegas Home! &nbsp;Spin the reels and enjoy real Vegas casino slot action!</p>
        <p class="text-xs-left">Start playing today and instantly get access to the most exclusive, authentic slots on the go! Receive FREE WELCOME COINS and special perks just for playing, for FREE! &nbsp;Show Me Vegas Slots gives you instant access to exclusive real slot machine games played in casinos around the world.</p>
        <p class="text-xs-left">Relive classic favorites like “Ghost Island”, “Fishing Bob”, "Super Sally’s Shrimpmania”, “Prince of Thieves”, "Phone Tag”, and many MORE, all packed with unique features and fun gameplay!</p>
        <p class="text-xs-left">From the creators of “Lucky Larry’s Lobstermania!” and “Stinkin’ Rich”, and many more… Show Me Vegas Slots will have you spinning for hours with HUGE PAYOUTS and tons of action at your fingertips, the excitement never stops!</p>
        <p class="text-xs-left">GAME FEATURES:</p>
        <p class="text-xs-left">FREE PRIZES: <br>Start rich with Millions of FREE COINS daily.</p>
        <p class="text-xs-left">DAILY BONUS WHEEL: <br>Win Millions of FREE casino bonus coins with the Daily Wheel and Casino Bonuses!</p>
        <p class="text-xs-left">BONUS POWER UPS: <br>Grab limited-time value offers to boost coin bonus and jackpot wins.</p>
        <p class="text-xs-left">DAILY CHALLENGES: <br>Complete new tasks &amp; exciting missions every day to unlock huge mystery treasure chest prizes.</p>
        <p class="text-xs-left">UNIQUE SLOT GAME FEATURES: <br>Slot games are packed with special bonus features and exciting wins.</p>
        <p class="text-xs-left">BIG ACTION JACKPOTS: <br>Unique progressive jackpots with tons of action. Celebrate big wins with linked progressives and Big Action Jackpots. Best Hot Slots in town!</p>
        <p class="text-xs-left">HIGH LIMIT ROOM: <br>Mystery Billions Jackpots await! Spin like a high roller on exclusive games and win HUGE!</p>
        <p class="text-xs-left">CLASSIC GAME ROOM: <br>A brand new game room with free-to-play Classic Vegas Casino Slot Machines.</p>
        <p class="text-xs-left">CASH BLAST SLOT TOURNAMENTS: <br>Compete against players from around the world in exciting multiplayer slot tournaments. Including Cash Blast Shootout and Cash Blast Speedway slot tournaments!</p>
        <p class="text-xs-left">BE SOCIAL, GET REWARDED: <br>Share COINS and your BIG WINS with all your friends!</p>
        <p class="text-xs-left">VIP DISCOUNTS &amp; FREE BONUSES: <br>VIP program for all players, enjoy special perks, free coins and HUGE savings.</p>
        <p class="text-xs-left">Just for you! &nbsp;Play your favorite casino slot games at Show Me Vegas Slots. &nbsp;Available for you everywhere you go on web &amp; mobile. &nbsp;Install today, good luck and have fun!</p>
        <p class="text-xs-left">#ShowMeVegasSlots #ShowMeVegas #ShowMeVegasSlotsCasino #ShowMeBigPayouts</p>
        <p class="text-xs-left">#ShowMeFreeBonus #ShowMeJackpots #SuperSally #Shrimpmania #GhostIsland</p>
        <p class="text-xs-left">#FishingBob #PrinceOfThieves #PhoneTag #StateFair</p>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
export default {
  data () {
    return {
      googlePlay: require('../../assets/buttons/Button_GooglePlayEnabled-smv.png'),
      iosStore: require('../../assets/buttons/Button_AppStoreEnabled-smv.png'),
      smvFacebook: require('../../assets/buttons/Button_FindUsEnabled.png'),
      smvIcon: require('../../assets/ShowMeVegasSlotsLogo.png'),
      smvButton: require('../../assets/buttons/Button_PlayForFreeEnabled.png'),
      smvHover: require('../../assets/buttons/Button_PlayForFreeOver.png'),
      smvPhone: require('../../assets/SocialGames/Phone_SMVS.png'),
      screenshots: [
        require('../../assets/AppScreenshots/SMVS/googleplay_2208x1242_01_ShrmpMnia.png'),
        require('../../assets/AppScreenshots/SMVS/googleplay_2208x1242_02_GhstIslnd.png'),
        require('../../assets/AppScreenshots/SMVS/googleplay_2208x1242_03_FishBob_5R.png'),
        require('../../assets/AppScreenshots/SMVS/googleplay_2208x1242_04_EgyptHldRspn_5R.png'),
        require('../../assets/AppScreenshots/SMVS/googleplay_2208x1242_05_PrncOThv_5R.png'),
        require('../../assets/AppScreenshots/SMVS/googleplay_2208x1242_06_TournamentsChallenges.png'),
        require('../../assets/AppScreenshots/SMVS/googleplay_2208x1242_07_Wheel.png'),
        require('../../assets/AppScreenshots/SMVS/googleplay_2208x1242_08_FeatureGraphic.png')
      ]
    }
  },
  computed: {
    mobile () {
      return navigator.userAgent.toLowerCase().indexOf('iphone') > -1 || navigator.userAgent.toLowerCase().indexOf('android') > -1
    },
    ipad () {
      return navigator.userAgent.toLowerCase().indexOf('ipad') > -1
    }
  },
  methods: {
    // smvClick () {
    //   window.open('https://showmevegasslots.onelink.me/uBTP?promoLink=UmMlkY2Q4dYjMkW7&utm_source=KSGWebSite&utm_medium=ksg_website_web&utm_campaign=Persistent%2Cwebsite_connect%2CNULL%2CNULL&utm_content=NULLApp_Button&utm_term=G1%2CV0%2CNULL%2CR0%2C&af_dp=com.ksgmobileinc.showmevegasslotsv2%3A%2F%2F', '_blank')
    // },
    changeButton (term) {
      let termArr = term.split('-')
      let platform = termArr[0]
      let el = document.querySelector(`#${platform}Btn`)
      let image = this[termArr[1]]
      el.src = image
      el.srcset = image
      // let el = document.querySelector(`#smvBtn div.v-image__image--cover`)
      // el.style.backgroundImage = 'url(' + this.smvHover + ')'
    },
    defaultButton (term) {
      let termArr = term.split('-')
      let platform = termArr[0]
      let el = document.querySelector(`#${platform}Btn`)
      let image = this[termArr[1]]
      el.src = image
      el.srcset = image
      // let el = document.querySelector(`#smvBtn div.v-image__image--cover`)
      // el.style.backgroundImage = 'url(' + this.smvButton + ')'
    }
  }
}
</script>

<style lang="css" scoped>
.parallax-container {
  /* width: 35%; */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  /* justify-content: center; */
}

.smv-container {
  /* width: 35%; */
  /* margin: 0; */
}

.screenshots-container {
  display: grid;
  grid-template-columns: 5px 1fr 5px;
}

.screenshots-container > * {
  grid-column: 2 / -2;
}

.screenshots-container > .full {
  grid-column: 1 / -1;
}

.horizontal-scroll {
  display: grid;
  grid-gap: 10px;
  /* grid-template-columns: repeat(8, calc(50% - 40px)); */
  grid-template-columns: repeat(8, 90%);
  grid-template-rows: minmax(200px, 1fr);
  overflow-x: scroll;
}

.overall-container {
  height: 100%;
}

.banner-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  height: 100%;
  padding: 1rem;
  grid-gap: 2rem;
}

.phone-smv {
  background-size: cover;
  display: grid;
  place-self: end;
  height: 90%;
  align-self: center;
}

.gameImg {
  /* width: 128px;
  height: 128px; */
}

.more-styling {
  /* width: 40%;
  margin: 0;
  margin-left: 1rem; */
  color: white;
}

.about-title {
  font-size: 2rem;
  font-weight: 900;
  letter-spacing: -1px;
  line-height: 99%;
  margin-bottom: 0.5rem;
}

.about-subtitle {
  /* font-size: 2rem; */
  font-weight: 800;
  /* letter-spacing: -1px; */
  line-height: 99%;
  margin-bottom: 1rem;
}

.iframe-container {
  position: relative;
  width: 100%;
  padding-bottom: 60%;
  height: 0;
}

.iframe-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

sup {
  vertical-align: sub;
}
</style>
